module.exports = __webpack_public_path__ + "static/img/4.70bd7f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengjian/4.jpg
// module id = JP09
// module chunks = 6